import { QuestionnaireType } from '../../shared/enums/questionnaire-type.enum';
import { ThankYouType } from '../../shared/enums/thank-you-type.enum';
import { Answer } from '../answer/answer.model';
import { Question } from '../questions/question.model';
import { Step } from './step.model';
import { QuestionMapper } from '../../question-mapper';
import { AnswerMapper } from '../../answer-mapper';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class QuestionStep extends Step {
  public questionnaireType!: QuestionnaireType;

  public question!: Question;

  public answer?: Answer;

  public override thankYouType!: ThankYouType;

  public static fromDto(dto: any): QuestionStep {
    const step: QuestionStep = new QuestionStep();
    Step.mapBaseProperties(step, dto);
    step.questionnaireType = dto.questionnaireType;
    step.question = QuestionMapper.fromDto(dto.question);
    step.answer = dto.answer ? AnswerMapper.fromDto(dto.answer) : undefined;
    step.thankYouType = dto.thankYouType;
    return step;
  }
}
